import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {isEmpty, debounce, unset, startCase} from 'lodash';

import ContactFormComponent from '../components/ContactForm';
import Layout from '../../shared/components/layouts/MainLayout';

import {
  createUserContact,
  fetchUserContacts,
  updateUserContact,
} from '../../contacts/contactsActions';
import {
  updatePurchaseOrder,
  fetchPurchaseOrder,
} from '../purchaseOrdersActions';
import {updateInvoice, fetchInvoice} from '../invoicesActions';

import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  PageViewName,
  TrackEventName,
} from '../../shared/constants/SegmentEvents';

export class ContactForm extends Component {
  constructor(props) {
    super(props);

    this.parentNode = React.createRef();

    this.state = {
      contact: {},
      contacts: [],
      isNewContact: true,
      errors: {},
    };
  }

  componentWillMount() {
    this.getTradeDocument();
    this.props.getContacts();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  componentDidMount() {
    segmentEventTracker.trackPageView(PageViewName.ADD_CONTACT_VIEWED);
  }

  filterContacts = e => {
    let {name, value} = e.target;
    value = value.replace(/\s+/g, ' ').trim();

    if (value.length < 3) {
      return [];
    }
    if (name !== 'full_name') {
      return this.state.contacts;
    }

    let contacts = [];
    let regex = new RegExp(`\\w*${value}\\w*`, 'i');

    if (value.length > 0) {
      contacts = this.props.contacts.filter(contact =>
        regex.test(`${contact.first_name} ${contact.last_name}`),
      );
    }

    this.setState({contacts: contacts}, () => {
      if (contacts.length > 0) {
        document.addEventListener('click', this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', this.handleOutsideClick, false);
      }
    });
  };

  selectContact = contact => {
    segmentEventTracker.trackEvent(TrackEventName.CONTACT_DROPDOWN_CLICKED);
    let fullName = contact.first_name + ' ' + contact.last_name;
    let newContact = {
      full_name: fullName,
      landline_number: contact.work_contact_number,
      mobile_number: contact.personal_contact_number,
      email_address: contact.email_address,
      id: contact.id,
    };

    this.setState({
      contact: newContact,
      contacts: [],
      isNewContact: false,
      selectedName: fullName,
      errors: {},
    });
  };

  checkIfNewContact = element => {
    if (element.name !== 'full_name' || !this.state.selectedName) {
      return this.state.isNewContact;
    }

    return (
      element.value.toLowerCase() !== this.state.selectedName.toLowerCase()
    );
  };

  getTradeDocument = () => {
    if (this.docType.includes('purchase_orders')) {
      this.props.fetchPurchaseOrder(
        this.props.tradeDocId,
        this.props.user.id,
        () => {},
        () => {},
      );
    } else if (this.docType.includes('invoices')) {
      this.props.fetchInvoice(
        this.props.tradeDocId,
        this.props.user.id,
        () => {},
        () => {},
      );
    }
  };

  onBack = () => {
    this.props.redirectBack(`/${this.docType}/${this.props.tradeDocId}/new`);
  };

  backButtonAction = () => {
    segmentEventTracker.trackEvent(TrackEventName.BACK_CLICKED);
    this.onBack();
  };

  onInputChange = e => {
    const value = e.target.value;
    let errors = this.state.errors;

    if (errors[e.target.name]) {
      unset(errors, e.target.name);
    }

    let new_contact = Object.assign({}, this.state.contact, {
      [e.target.name]: value,
    });

    if (e.target.name === 'full_name') {
      e.persist();
      debounce(this.filterContacts, 500)(e);
    }
    this.setState({
      contact: new_contact,
      errors: errors,
      isNewContact: this.checkIfNewContact(e.target),
    });
  };

  handleOutsideClick = e => {
    // ignore clicks on the component itself
    if (this.parentNode && this.parentNode.current.contains(e.target)) {
      return;
    }

    this.setState({contacts: []});
  };

  get fieldErrors() {
    return {
      full_name: "Buyer's full name required",
      email_address: 'Email address is required',
      landline_number: 'Business landline number is required',
    };
  }

  get checkFormInvalid() {
    let {errors, contact} = this.state;

    if (Object.values(contact).length === 0) {
      errors = this.fieldErrors;
    }

    if (!contact.full_name || contact.full_name.length === 0) {
      errors.full_name = this.fieldErrors.full_name;
    }

    if (!contact.email_address || contact.email_address.length === 0) {
      errors.email_address = this.fieldErrors.email_address;
    }

    if (!contact.landline_number || contact.landline_number.length === 0) {
      errors.landline_number = this.fieldErrors.landline_number;
    }

    let reg = /^[^@\s]+@([^@\s]+\.)+[^@\s]+$/;
    if (contact.email_address && reg.test(contact.email_address) === false) {
      errors.email_address = 'Email format is not valid';
    }

    let nameRegex = /\w+\s+(\w+){1,}/;
    if (contact.full_name && nameRegex.test(contact.full_name) === false) {
      errors.full_name = 'Please enter both a first and last name';
    }

    if (Object.values(errors).length > 0) {
      this.setState({errors: errors});
      return true;
    }

    return false;
  }

  get docType() {
    return `${this.props.type}s`;
  }

  redirectBack = () => {
    let route = {
      pathname: '/applications',
      state: {successMessage: this.successMessage()},
    };

    this.props.redirectBack(route);
  };

  successCallBack = () => {
    let userId = this.props.user.id;
    let tradeDoc = {};

    if (this.docType.includes('purchase_orders')) {
      tradeDoc = {
        purchase_order_document_attributes: {
          id: this.props.documentId,
          status: 'under verification',
        },
        buyer_contacts_purchase_orders_attributes: [
          {purchase_order_id: this.props.tradeDocId},
        ],
      };
    } else if (this.docType.includes('invoices')) {
      tradeDoc = {
        invoice_document_attributes: {
          id: this.props.documentId,
          status: 'under verification',
        },
        buyer_contacts_invoices_attributes: [
          {invoice_id: this.props.tradeDocId},
        ],
      };
    }

    return response => {
      if (this.docType.includes('purchase_orders')) {
        tradeDoc.buyer_contacts_purchase_orders_attributes[0].buyer_contact_id =
          (response && response.id) || this.state.contact.id;
        let body = JSON.stringify({purchase_order: tradeDoc});
        this.props.updatePurchaseOrder(
          this.props.tradeDocId,
          userId,
          body,
          this.redirectBack,
        );
      } else if (this.docType.includes('invoices')) {
        tradeDoc.buyer_contacts_invoices_attributes[0].buyer_contact_id =
          (response && response.id) || this.state.contact.id;
        let body = JSON.stringify({invoice: tradeDoc});
        this.props.updateInvoice(
          this.props.tradeDocId,
          userId,
          body,
          this.redirectBack,
        );
      }
    };
  };

  getPayload = () => {
    // NOTE: Splitting the name so that last word is set to last_name
    // and first set of words to first_name because in db fields are first name and last name
    // whereas design has full_name text field

    let contact = this.state.contact;
    let name = this.nameArray;

    return {
      first_name: name[0],
      last_name: name[1],
      email_address: contact.email_address,
      work_contact_number: contact.landline_number,
      personal_contact_number: contact.mobile_number,
    };
  };

  get nameArray() {
    let name = this.state.contact.full_name.split(' ');

    let first_name = (name.length > 1
      ? name.splice(0, name.length - 1)
      : name.splice(0, 1)
    ).join(' ');
    let last_name = name.pop();

    return [first_name, last_name];
  }

  formSubmit = e => {
    e.preventDefault();

    if (this.checkFormInvalid) {
      return false;
    }

    if (this.state.isNewContact) {
      this.props.createUserContact(
        this.props.user.id,
        this.getPayload(),
        this.successCallBack(),
      );
    } else {
      this.props.updateUserContact(
        {userId: this.props.user.id, contactId: this.state.contact.id},
        this.getPayload(),
        this.successCallBack(),
      );
    }
  };

  onClickSubmitButton = e => {
    e.preventDefault();
    segmentEventTracker.trackEvent(TrackEventName.SUBMIT_FORM_CLICKED);
    this.formSubmit(e);
  };

  successMessage = () => {
    let docType = startCase(this.props.type.replace('_', ' '));

    return `${docType} has been uploaded successfully!`;
  };

  render() {
    return (
      <Layout
        gridClassName="--narrow"
        backButtonAction={this.backButtonAction}
        header="Add a Contact Person">
        <ContactFormComponent
          handleChange={this.onInputChange}
          contact={this.state.contact}
          errors={this.state.errors}
          attachments={this.props.attachments}
          handleSubmit={this.formSubmit}
          contacts={this.state.contacts}
          selectContact={this.selectContact}
          ref={this.parentNode}
          onClickSubmitButton={this.onClickSubmitButton}
        />
      </Layout>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    user: state.user,
    documentId: isEmpty(state[`${props.type}s`].present)
      ? ''
      : state[`${props.type}s`].present[`${props.type}_document`].id,
    attachments: isEmpty(state[`${props.type}s`].present)
      ? []
      : state[`${props.type}s`].present[`${props.type}_document`][
          `${props.type}_attachments`
        ],
    contacts: state.contacts.user_contacts,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    redirectBack: path => {
      dispatch(push(path));
    },
    getContacts: userId => {
      dispatch(fetchUserContacts(userId));
    },
    fetchInvoice: (id, userId, success, error) => {
      dispatch(fetchInvoice(id, userId, success, error));
    },
    fetchPurchaseOrder: (id, userId, success, error) => {
      dispatch(fetchPurchaseOrder(id, userId, success, error));
    },
    updateInvoice: (tradeId, userId, body, successCallBack) => {
      dispatch(updateInvoice(tradeId, userId, body, successCallBack, true));
    },
    updatePurchaseOrder: (tradeId, userId, body, successCallBack) => {
      dispatch(
        updatePurchaseOrder(tradeId, userId, body, successCallBack, true),
      );
    },
    createUserContact: (userId, payload, successCallback) => {
      dispatch(createUserContact(userId, payload, successCallback));
    },
    updateUserContact: (urlOpts, body, successCallback, errorCallback) => {
      dispatch(
        updateUserContact(urlOpts, body, successCallback, errorCallback),
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactForm);



// WEBPACK FOOTER //
// ./src/features/trade_documents/containers/ContactForm.js